<!--
 * @Description: 学生完成情况
 * @Author: black-k
 * @Date: 2025-09-17 17:27:10
 * @LastEditors: black-k
 * @LastEditTime: 2025-11-10 16:25:31
-->
<template>
    <div class="student-completion">
        <div class="completion-header">
            <div class="header-btn flex-center" @click="$router.back()">返回</div>
        </div>

        <div class="completion-user flex-center">
            <div class="user-info flex-center">
                <img :src="$route.query.avatar" alt="" />
                <span>{{ $route.query.name }}</span>
            </div>

            <div class="task-info flex-center">
                <div class="task-info_item flex-center">
                    <div class="item-header">完成企业任务</div>

                    <div class="item-value">{{ taskInfo.enterprise }}</div>
                </div>

                <div class="task-info_item flex-center">
                    <div class="item-header">完成教师任务</div>

                    <div class="item-value">{{ taskInfo.teacher }}</div>
                </div>
            </div>
        </div>

        <div class="completion-box">
            <div class="box-tabs">
                <div
                    :class="['tab-item', { active: tab.value === currentTab }]"
                    v-for="tab in tabList"
                    :key="tab.value"
                    @click="handleTabChange(tab)"
                >
                    {{ tab.label }}
                </div>
            </div>

            <div class="box-list">
                <div class="list-empty flex-center" v-if="taskList.length === 0">暂无数据</div>

                <template v-else>
                    <TaskList :task-list="taskList">
                        <template slot-scope="scope">
                            <div class="btn flex-center" @click="handleToTask(scope.task)">查看任务</div>
                        </template>
                    </TaskList>

                    <div class="list-pagination flex-center">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pageParams.page"
                            :page-size="pageParams.page_size"
                            layout="prev, pager, next, jumper"
                            :total="pageParams.total"
                        >
                        </el-pagination>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import taskApi from "../../../apis/task";
import TaskList from "@/components/new-task/TaskList.vue";

export default {
    data() {
        return {
            // 学生完成情况
            taskInfo: {
                // 学生任务数据
                enterprise: 0,
                teacher: 0,
            },

            currentTab: 2,
            tabList: [
                { label: "完成企业任务", value: 2 },
                { label: "完成教师任务", value: 1 },
            ],

            pageParams: {
                page: 1,
                page_size: 12,
                total: 0,
            },

            taskList: [],
        };
    },

    created() {
        if (this.$route.query.id) {
            this.getTaskInfo();
            this.getTaskList();
        }
    },

    components: {
        TaskList,
    },

    methods: {
        handleTabChange(tab) {
            this.currentTab = tab.value;
            this.pageParams.page = 1;

            this.getTaskList();
        },

        // 获取企业任务数据
        getTaskInfo() {
            const params = { user_id: Number(this.$route.query.id) };

            this.$httpteacher.axiosGetBy(taskApi.studentTaskInfo, params, (res) => {
                if (res.code === 200) {
                    this.taskInfo = {
                        enterprise: res.data?.enterprise ?? 0,
                        teacher: res.data?.teacher ?? 0,
                    };
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 获取任务完成列表
        getTaskList() {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                filter_user: Number(this.$route.query.id),
                user_type: this.currentTab,
                filter_status: 3,
                not_deleted: false,
            };

            this.$httpteacher.axiosPost(taskApi.studentTaskList, params, (res) => {
                if (res.code === 200) {
                    this.pageParams.total = res.data?.total || 0;
                    this.taskList = res.data?.list || [];
                } else {
                    this.$message.warning(res.message);
                }
            });
        },

        handleSizeChange(val) {
            console.log("page size: ", val);
        },

        handleCurrentChange(val) {
            // console.log("page current: ", val);
            this.pageParams.page = val;

            this.getTaskList();
        },

        handleToTask(task) {
            if (task.delete_time !== 0) {
                this.$message.warning("需求已被下架，无法查看");
                return;
            }

            const url = this.$router.resolve({
                path: "/teacher/newTask/detail",
                query: {
                    id: task.id,
                },
            }).href;

            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.student-completion {
    .completion-header {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;

        .header-btn {
            cursor: pointer;
            width: 88px;
            height: 32px;
            background-color: #584eee;
            border-radius: 4px;
            color: #ffffff;
        }
    }

    .completion-user {
        height: 265px;
        background: url("../../../assets/img/image/task-info-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 4px;
        flex-direction: column;

        .user-info {
            gap: 20px;

            img {
                height: 80px;
                width: 80px;
                object-fit: cover;
                border-radius: 50%;
            }

            span {
                font-size: 16px;
            }
        }

        .task-info {
            margin-top: 40px;
            gap: 100px;
            font-size: 16px;

            &_item {
                flex-direction: column;
                gap: 10px;

                .item-header {
                    color: #999;
                }
            }
        }
    }

    .completion-box {
        margin-top: 20px;

        .box-tabs {
            padding-left: 20px;
            display: flex;
            align-items: center;
            gap: 40px;

            .tab-item {
                position: relative;
                height: 30px;
                cursor: pointer;

                &::before,
                &::after {
                    content: "";
                    position: absolute;
                    background-color: #9acb5f;
                    display: none;
                }

                &::before {
                    width: 5px;
                    height: 5px;
                    transform: translateX(-50%) rotate(45deg);
                    left: 50%;
                    bottom: 0;
                    border-bottom-right-radius: 50%;
                }

                &::after {
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 3px;
                }

                &.active {
                    &::before,
                    &::after {
                        display: block;
                    }
                }
            }
        }

        .box-list {
            --remain-height: calc(100vh - 507px);
            padding: 40px 34px 72px;
            margin-top: 20px;
            min-height: var(--remain-height);
            background-color: #ffffff;
            border-radius: 4px;
            box-sizing: border-box;
            position: relative;

            .list-empty {
                height: calc(var(--remain-height) - 112px);
                font-size: 16px;
                color: #999;
            }

            // @media (max-width: 1580px) {
            //     .task-list {
            //         --count: 3;
            //     }
            // }

            // @media (max-width: 1264px) {
            //     .task-list {
            //         --count: 2;
            //     }
            // }

            .list-pagination {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                padding-bottom: 20px;
            }
        }
    }
}
</style>
